module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0096.jpg?v=047e3805";